import { Loader2 } from "lucide-react";
import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

interface ConsoleLoaderProps {
  count: number;
  onReconnect?: () => void;
  reconnecting?: boolean;
}

const ConsoleSkeleton = () => {
  const getRandomWidth = (): string => {
    const widths = [
      "1/12",
      "2/12",
      "3/12",
      "4/12",
      "5/12",
      "7/12",
      "8/12",
      "9/12",
      "10/12",
    ];
    return widths[Math.floor(Math.random() * widths.length)];
  };

  return (
    <Skeleton
      className={`h-2 w-${getRandomWidth()} rounded-xs bg-secondary-300 shrink-0`}
    />
  );
};

export const Loader = ({
  count,
  onReconnect,
  reconnecting,
}: ConsoleLoaderProps) => {
  const skeletonElements = useMemo(() => {
    return Array.from({ length: count }, (_, index) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: its static
      <ConsoleSkeleton key={index} />
    ));
  }, [count]);

  return (
    <div className="w-full flex flex-col gap-1.5 relative h-full overflow-hidden p-2">
      {skeletonElements}
      {onReconnect && (
        <Button
          className={cn(
            // Put in middle absolutely
            "absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2",
            !onReconnect && "hidden",
          )}
          variant="outline"
          size="sm"
          onClick={() => {
            onReconnect();
          }}
        >
          <div className={cn("animate-spin mr-1", !reconnecting && "hidden")}>
            <Loader2 className="h-4 w-4" />
          </div>
          Reconnect
        </Button>
      )}
    </div>
  );
};
